import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import SaveButton from "../../../components/Buttons/SaveButton";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import { useNotifications } from "../../../contexts/notificationContext";
import ColorModel from "../../../models/ColorModel";
import ItemRevisionColorModel from "../../../models/ItemRevisionColorModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";
import ColorMiniCard from "../Components/ColorMiniCard";

interface IProps {
    show: boolean
    onHide: (addedItemColors?: ItemRevisionColorModel[]) => void
    itemRevisionId: number
}

interface ItemRevisionColorsCreateModel {
    itemRevisionId: number
    colorIds: number[]
}

const AddItemColorPopup: React.FC<IProps> = ({ show, onHide, itemRevisionId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] })
    const [colors, setColors] = useState<ColorModel[]>([])
    const { handleResult, handleException } = useNotifications()
    const [showSpinner, setShowSpinner] = useState(false)

    const [formData, setFormData] = useState<ItemRevisionColorsCreateModel>({ itemRevisionId: itemRevisionId, colorIds: [] })

    useEffect(() => {
        DataService
            .get<ColorModel[]>(`api/v1/Colors`)
            .then(response => setColors(response))
    }, [])

    function handleItemClicked(selectedColor: ColorModel) {
        if (formData.colorIds.includes(selectedColor.id))
            formData.colorIds.splice(formData.colorIds.indexOf(selectedColor.id), 1)
        else
            formData.colorIds.push(selectedColor.id)

        setFormData({ ...formData })
    }

    function submit() {
        if (formData) {
            setShowSpinner(true)
            DataService
                .create<ItemRevisionColorModel[]>(`api/v1/ItemRevisionColors/CreateMultiple`, formData)
                .then(response => {
                    setShowSpinner(false)
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data) 
                        onHide(response.data);
                })
                .catch(e => { setShowSpinner(false); handleException(e) });
        }
    }

    function addAll() {
        if (colors) {
            formData.colorIds = colors.map(x => Number(x.id))
            setFormData({ ...formData })
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'colorIds', label: 'Colors', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    let results = colors.map((item, index) => {
        var isSelected = formData.colorIds.filter(x => x == item.id).length > 0
        return <ColorMiniCard color={item} isSelected={isSelected} handleItemClicked={handleItemClicked} key={index} />
    });

    return (
        <>
            <Popup show={show} onHide={onHide} size={'xxl'} title={'Add colors'} >
                <Popup.Body>
                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                        {results}
                    </div>
                </Popup.Body>
                <Popup.Footer>
                    <Button type='button' text='Select all colors' onClick={addAll} />
                    <SaveButton {...getSubmitButtonProps()} text='Add' />
                </Popup.Footer>
            </Popup>
            {showSpinner && <SpinnerOverlay />}
        </>
    );
}
export default AddItemColorPopup;